import { FC, memo } from 'react';
import { StatisticsSectionsTable } from '../shared/StatisticsSectionsTable/StatisticsSectionsTable';
import { OutgoingStatisticRow } from './buildOutgoingStatisticRows';
import styles from './style.module.css';

interface Props {
  dataSource: OutgoingStatisticRow[];
  loading?: boolean;
  sectionModes?: Readonly<Record<string, string>>;
  onSectionModeChange?: (sectionKey: string, mode: string) => void;
}

export const OutgoingStatistics: FC<Props> = memo(
  ({
    dataSource,
    loading = false,
    sectionModes,
    onSectionModeChange,
  }: Props) => {
    return (
      <StatisticsSectionsTable
        dataSource={dataSource}
        loading={loading}
        className={styles.OutgoingStatistics}
        displayName="OutgoingStatistics"
        sectionModes={sectionModes}
        onSectionModeChange={onSectionModeChange}
      />
    );
  },
);

OutgoingStatistics.displayName = 'OutgoingStatistics';
